<template>
  <div id="orgRegisterWx">
    <OrgRegisterStepWx
      :orgData.sync='orgData'
      @onSuccessRegister="onSuccessRegister()"
      @onSuccessPass="onSuccessPass()"
      class="register-container"
    />
  </div>
</template>
<script>
import OrgRegisterStepWx from '@/components/org/register/OrgRegisterStepWx';
export default {
  components: {
    OrgRegisterStepWx
  },
  data() {
    return {
      orgData: {
        departRegisterId: null,
        departName: null,
        agreeService: false,
        trueName: null,
        userPhone: null,
        userEmail: null,
        userPassword: null,
        userPassword1: null,
        creditCode: null,
        orgType: null,
        legalPerson: null,
        registerCapital: null,
        foundingDate: null,
        busiTermStart: null,
        busiTermEnd: null,
        regOffice: null,
        approvalDate: null,
        regStatus: null,
        registerAddress: null,
        busiScope: null,
        businessLicense: null,
        orgSelectStatus: false,
        openid: '',
        unionid: '',
        nickname: '',
        headimgurl: '',
        saveType: 0
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$root.layout.isLoading = false;
      let orgRegisterData = sessionStorage.getItem('orgRegisterData');
      if (orgRegisterData) {
        this.orgData = JSON.parse(orgRegisterData);
      }
    },
    onSuccessRegister: function() {
      sessionStorage.removeItem('orgRegisterData');
      this.$router.push('/org/register/stepfour');
    },
    onSuccessPass: function() {
      sessionStorage.removeItem('orgRegisterData');
      this.$router.push('/org/register/stepfive');
    }
  }
};
</script>
<style lang="less" scoped>
#orgRegisterWx {
  width: 100%;
  .register-container {
    height: 920px;
    width: 100%;
    background: #cbcaca;
  }
}
</style>
